import { TCompanyId, TLenderId, TLoanId } from 'src/lib/models';
import { DateRange } from '/src/lib/types';

export type BarChartFilters = {
  companyId?: TCompanyId;
  loanId?: TLoanId;
  lenderId?: TLenderId;
  category?: string;
  [key: string]: string | undefined;
};

export type Chart = {
  parent: HTMLElement;
  dimensions: ChartDimensions;
  name: string;
  render?: boolean;
  margins?: ChartMargins;
};

export type ChartType = string;
export type Color = string;

export type ChartColors = Record<ChartType, Color[]>;

export type ChartDimensions = {
  width: number;
  height: number;
};

export type ChartMargins = {
  top: number;
  right: number;
  bottom: number;
  left: number;
  xAxis: number;
  yAxis: number;
  [key: string]: number;
};

export type ChartPosition = {
  x?: number;
  dx?: number;
  y?: number;
  dy?: number;
  transform?: string;
};

export type ChartRange = {
  values: DateRange;
  type: string;
};

export type ChartDomain = {
  domain: string;
};

export type ChartScale = {
  scale: any;
  range?: ChartRange;
  domain?: ChartDomain;
};

export type ChartTicks = {
  number?: number;
  format?: string;
};

export type ChartAxis = {
  chart?: any; // maybe Chart entity?
  axis?: any; // D3 Axis
  scale?: ChartScale;
  classes?: string[];
  orientation?: any;
  ticks?: ChartTicks;
  element: any; // D3 Element
};

export type ChartAxisLabel = {
  axis?: any; // D3 Axis
  text: string;
  position?: string[];
  classes?: string[];
  styles?: string[];
  element: any; // D3 Element
};

export type ChartFilter = {
  name: string;
};
